import style from './style.module.scss'
import { default as SliderToggle } from 'pages/PartnerNetwork/Toggle'
import { Text } from '@crossfit/design-system'

export enum ToggleValue {
  PUBLIC = 'Public',
  PRIVATE = 'Private',
}

export interface ToggleProps {
  toggleValue: ToggleValue
  onToggle?: (state: ToggleValue) => void
}

export default function Toggle(props: ToggleProps) {
  const onToggleChange = (e) => {
    const newtoggleValue = e.target.checked
      ? ToggleValue.PUBLIC
      : ToggleValue.PRIVATE

    props.onToggle(newtoggleValue)
  }
  return (
    <div className={style.toggleContainer}>
      <SliderToggle onChange={onToggleChange} state={props.toggleValue} />
      <Text size='sm' type='body' className={style.publicText}>
        {props.toggleValue?.toString()}
      </Text>
    </div>
  )
}
